<script lang="ts" setup>
import { computed } from "vue";
import { useMate } from "@/stores/mate";
import { useRouter } from "vue-router";
import { useReply } from "@/stores/reply";
import { Reply } from "@/types/entity";

const props = defineProps<{
  reply?: Reply;
}>();
const mate = useMate();
const reply = useReply();
const router = useRouter();
const sortedReactionList = computed<Reply["emojiVotezz"]>(() => {
  if (!props.reply?.emojiVotezz) {
    return [];
  } else {
    return props.reply.emojiVotezz;
  }
});

const onClick = (e: UIEvent, item: EmojiVote) => {
  e.stopPropagation();
  router.push({
    name: "mateHome",
    params: {
      uuid: item.mate.uuid,
    },
  });
};
</script>
<template>
  <div v-if="sortedReactionList.length > 0" class="flex flex-wrap gap-1">
    <span
      v-for="item in sortedReactionList"
      :key="item.id"
      :class="{
        'text-primary': item.mate?.id === mate.currentMate?.id,
      }"
      class="text-xs cursor-pointer"
      @click="onClick($event, item)"
    >
      <span class="noto-color-emoji-regular">
        {{
          reply.emojiMap.get(item.emojiId)?.content
            ? reply.emojiMap.get(item.emojiId)?.content
            : item.emoji.content
        }}
      </span>
      {{ item.mate?.name ?? "" }}
    </span>
  </div>
</template>
